import { createSvgIcon } from '@mui/material/utils'

export const FileIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
    <path
      d="M12.25 2.25H5.25C4.78587 2.25 4.34075 2.43437 4.01256 2.76256C3.68437 3.09075 3.5 3.53587 3.5 4V18C3.5 18.4641 3.68437 18.9092 4.01256 19.2374C4.34075 19.5656 4.78587 19.75 5.25 19.75H15.75C16.2141 19.75 16.6592 19.5656 16.9874 19.2374C17.3156 18.9092 17.5 18.4641 17.5 18V7.5M12.25 2.25L17.5 7.5M12.25 2.25V7.5H17.5M14 11.875H7M14 15.375H7M8.75 8.375H7"
      stroke="#9AA4B2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'FileIcon'
)
